import * as actions from "./actions";
import { ActionType, getType } from "typesafe-actions";
import { AddressesState } from "./model/AddressesState";

export type AddressesAction = ActionType<typeof actions>;

const initialState: AddressesState = {
  addresses: [],
  isLoadingAddresses: false
};

export default (
  state: AddressesState = initialState,
  action: AddressesAction
): AddressesState => {
  switch (action.type) {
    case getType(actions.fetchAddressesAsync.request):
      return { ...state, isLoadingAddresses: true };
    case getType(actions.fetchAddressesAsync.success):
      return { ...state, addresses: action.payload, isLoadingAddresses: false };
    case getType(actions.fetchAddressesAsync.failure):
      return { ...state, isLoadingAddresses: false };
    default:
      return state;
  }
};
